import ControlViewModel from '@/ViewModels/ControlViewModel';
import WindowViewModel from '@/ViewModels/Controls/WindowViewModel';
import DropDownListViewModel from '@/ViewModels/Controls/DropDownListViewModel';
import ButtonViewModel from '@/ViewModels/Controls/ButtonViewModel';
import WindowViewModelT from '@/ViewModels/Controls/WindowViewModel';
import DropDownListViewModelT from '@/ViewModels/Controls/DropDownListViewModel';
import ButtonViewModelT from '@/ViewModels/Controls/ButtonViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import ImageViewModelT from '@/ViewModels/Controls/ImageViewModel';
import ResourceManager from '@/Management/ResourceManager';
import ComponentManager from '@/Management/ComponentManager';
import GlobalConfiguration from '@/Management/GlobalConfiguration';
export default class TypeSelectorWindowViewModel extends ControlViewModel {
    /**
    * Das Fenster in dem die Auswahl des Typen stattfindet
    * @type {WindowViewModel}
    */
    public window: WindowViewModel;
    /**
    * Die DropDownList zur Auswahl des Typen
    * @type {DropDownListViewModel}
    */
    public dropDownList: DropDownListViewModel;
    /**
    * Die Buttons innerhalb des Fensters
    * @type {[ButtonViewModel]}
    */
    public buttons: KnockoutObservableArray<ButtonViewModel>;
    constructor(params: any) {
        super(params);
        this.window = this.paramOrDefault(params.window, null);
        this.dropDownList = this.paramOrDefault(params.dropDownList, null);
        this.buttons = this.observableOrDefault(params.buttons, []) as KnockoutObservableArray<ButtonViewModel>;
        ControlViewModel.checkProperties(this, params);
    }
    /**
    * Erzeugt ein neues TypeSelectorWindowViewModel für die Auswahl einer Basisklasse
    */
    public static createBaseTypeSelectorWindow(types: Array<any>, callbackOK: (value: any) => any, baseLocator: ObservableOrDefault<string>, callbackAllways: () => any) {
        let WindowViewModel = ComponentManager.getViewModel<typeof WindowViewModelT>('WindowViewModel');
        let DropDownListViewModel = ComponentManager.getViewModel<typeof DropDownListViewModelT>('DropDownListViewModel');
        let ButtonViewModel = ComponentManager.getViewModel<typeof ButtonViewModelT>('ButtonViewModel');
        let LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
        let ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');
        let parentLocator = ko.computed(() => {
            if ($.isFunction(baseLocator))
                return [baseLocator(), 'base-type-selector'].join('.');
            else if (baseLocator)
                return [baseLocator, 'base-type-selector'].join('.');
            else
                return 'base-type-selector';
        });
        let data = ko.computed(() => {
            let resources = ResourceManager.getInstance().resources();
            let result = [];
            for (const type of types) {
                result.push({
                    name: type.name,
                    caption: resources[type.ergName],
                    iconUrl: type.iconUrl
                });
            }
            result = _.sortBy(result, 'caption');
            return result;
        });
        let dropDownListViewModel = new DropDownListViewModel({
            parentLocator: parentLocator,
            locator: 'value',
            data: data,
            dataTextField: 'caption',
            dataValueField: 'name',
            optionLabel: ' ',
            template: '<img src=\"#:data.iconUrl || \'\'#\" /> <span>#:data.caption#</span>',
            valueTemplate: '<img src=\"#:data.iconUrl || \'\'#\" /> <span>#:data.caption#</span>'
        });
        dropDownListViewModel.addComputed(data);
        let isEnabled = ko.computed(() => {
            let value = dropDownListViewModel.value();
            return value != null;
        });
        let selectBaseObjectWindowViewModel = new TypeSelectorWindowViewModel({
            parentLocator: parentLocator,
            locator: 'window',
            window: new WindowViewModel({
                parentLocator: parentLocator,
                locator: 'window',
                isModal: true,
                isOpen: true,
                allowClose: true,
                headline: new LabelViewModel({
                    ergName: 'BASE_OBJECT_WINDOW_TITLE'
                }),
                onClose: () => {
                    if (callbackAllways != null) {
                        callbackAllways();
                    }
                }
            }),
            dropDownList: dropDownListViewModel,
            buttons: [
                new ButtonViewModel({
                    parentLocator: parentLocator,
                    locator: 'window.button.ok',
                    isPrimaryButton: true,
                    image: new ImageViewModel({
                        parentLocator: parentLocator,
                        locator: 'window.button.ok.image',
                        source: GlobalConfiguration.inlineImages.WINDOW_OK,
                        alternativeText: new LabelViewModel({
                            ergName: 'OKAY'
                        })
                    }),
                    isEnabled: isEnabled,
                    label: new LabelViewModel({
                        parentLocator: parentLocator,
                        locator: 'window.button.ok.label',
                        ergName: 'OKAY'
                    }),
                    onClick: () => {
                        selectBaseObjectWindowViewModel.window.isOpen(false);
                        if (callbackOK != null) {
                            let value = dropDownListViewModel.value();
                            callbackOK(value);
                        }
                    }
                }),
                new ButtonViewModel({
                    parentLocator: parentLocator,
                    locator: 'window.button.cancel',
                    image: new ImageViewModel({
                        parentLocator: parentLocator,
                        locator: 'window.button.cancel.image',
                        source: GlobalConfiguration.inlineImages.WINDOW_CANCEL,
                        alternativeText: new LabelViewModel({
                            ergName: 'CANCEL'
                        })
                    }),
                    label: new LabelViewModel({
                        parentLocator: parentLocator,
                        locator: 'window.button.cancel.label',
                        ergName: 'CANCEL'
                    }),
                    onClick: () => {
                        selectBaseObjectWindowViewModel.window.isOpen(false);
                    }
                })
            ]
        });
        selectBaseObjectWindowViewModel.addComputed(isEnabled);
        return selectBaseObjectWindowViewModel;
    }
    /**
    * Erzeugt ein neues TypeSelectorWindowViewModel für die Auswahl einer Unterklasse
    */
    public static createSubTypeSelectorWindow(ergName: string, types: Array<any>, callbackOK: (value: any) => any, baseLocator: ObservableOrDefault<string>, callbackAllways: () => any) {
        let WindowViewModel = ComponentManager.getViewModel<typeof WindowViewModelT>('WindowViewModel');
        let DropDownListViewModel = ComponentManager.getViewModel<typeof DropDownListViewModelT>('DropDownListViewModel');
        let ButtonViewModel = ComponentManager.getViewModel<typeof ButtonViewModelT>('ButtonViewModel');
        let LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
        let ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');
        let parentLocator = ko.computed(() => {
            if ($.isFunction(baseLocator))
                return [baseLocator(), 'sub-type-selector'].join('.');
            else if (baseLocator)
                return [baseLocator, 'sub-type-selector'].join('.');
            else
                return 'sub-type-selector';
        });
        let data = ko.computed(() => {
            let resources = ResourceManager.getInstance().resources();
            let result = [];
            for (const type of types) {
                result.push({
                    name: type.name,
                    caption: resources[type.ergName],
                    iconUrl: type.iconUrl
                });
            }
            let counted = _.countBy(result, (type) => { return type.caption; });
            for (let caption in counted) {
                if (counted[caption] > 1) {
                    for (let j = 0; j < result.length; j++) {
                        if (result[j].caption === caption) {
                            let split = result[j].name.split('.');
                            split[split.length - 1] = result[j].caption;
                            result[j].caption = split.join('.');
                        }
                    }
                }
            }
            return result.sort((typeA, typeB) => {
                return (typeA.caption < typeB.caption) ? -1 : (typeA.caption > typeB.caption) ? 1 : 0;
            });
        });
        let dropDownListViewModel = new DropDownListViewModel({
            parentLocator: parentLocator,
            locator: 'value',
            data: data,
            value: data()[0].name,
            dataTextField: 'caption',
            dataValueField: 'name',
            template: '# if (data.iconUrl) { #<img src=\"#:data.iconUrl#\" /># } #<span>#:data.caption#</span>',
            valueTemplate: '# if (data.iconUrl) { #<img src=\"#:data.iconUrl#\" /># } #<span>#:data.caption#</span>',
        });
        dropDownListViewModel.addComputed(data);
        let isEnabled = ko.computed(() => {
            let value = dropDownListViewModel.value();
            return value != null;
        });
        let selectBaseObjectWindowViewModel = new TypeSelectorWindowViewModel({
            parentLocator: parentLocator,
            locator: 'window',
            window: new WindowViewModel({
                parentLocator: parentLocator,
                locator: 'window',
                isModal: true,
                isOpen: true,
                allowClose: true,
                headline: new LabelViewModel({
                    ergName: 'SELECT_TYPE_TITLE',
                    replacements: {
                        ergname: new LabelViewModel({
                            ergName: ergName
                        })
                    }
                }),
                onClose: () => {
                    if (callbackAllways != null) {
                        callbackAllways();
                    }
                }
            }),
            dropDownList: dropDownListViewModel,
            buttons: [
                new ButtonViewModel({
                    parentLocator: parentLocator,
                    locator: 'window.button.ok',
                    isPrimaryButton: true,
                    image: new ImageViewModel({
                        parentLocator: parentLocator,
                        locator: 'window.button.ok.image',
                        source: GlobalConfiguration.inlineImages.WINDOW_OK,
                        alternativeText: new LabelViewModel({
                            ergName: 'OKAY'
                        })
                    }),
                    isEnabled: isEnabled,
                    label: new LabelViewModel({
                        parentLocator: parentLocator,
                        locator: 'window.button.ok.label',
                        ergName: 'OKAY'
                    }),
                    onClick: () => {
                        selectBaseObjectWindowViewModel.window.isOpen(false);
                        if (callbackOK != null) {
                            let value = dropDownListViewModel.value();
                            callbackOK(value);
                        }
                    }
                }),
                new ButtonViewModel({
                    parentLocator: parentLocator,
                    locator: 'window.button.cancel',
                    label: new LabelViewModel({
                        parentLocator: parentLocator,
                        locator: 'window.button.cancel.label',
                        ergName: 'CANCEL'
                    }),
                    image: new ImageViewModel({
                        parentLocator: parentLocator,
                        locator: 'window.button.cancel.image',
                        source: GlobalConfiguration.inlineImages.WINDOW_CANCEL,
                        alternativeText: new LabelViewModel({
                            ergName: 'CANCEL'
                        })
                    }),
                    onClick: () => {
                        selectBaseObjectWindowViewModel.window.isOpen(false);
                    }
                })
            ]
        });
        selectBaseObjectWindowViewModel.addComputed(isEnabled);
        return selectBaseObjectWindowViewModel;
    }
    protected disposeInternal(): void {
        if (this.window && !this.window.isDisposed) {
            this.window.isOpen(false);
            this.window.dispose();
        }
        super.disposeInternal();
    }
}

ComponentManager.setViewModel('TypeSelectorWindowViewModel', TypeSelectorWindowViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');